const COD_PATTERN = /\b(cod|cash\s*on\s*delivery|releasit)\b/i;
const PRODUCT_AND_CART_SCOPES = [
  '.product-information',
  '.product-information .buy-buttons-block',
  '.product-information product-form-component',
  '.cart-page',
  '.cart__ctas',
  '.cart-summary',
  '.cart-drawer',
];

function getElementText(element) {
  return [
    element.textContent,
    element.getAttribute('aria-label'),
    element.getAttribute('title'),
    element.getAttribute('value'),
    element.getAttribute('data-button-text'),
    element.className,
    element.id,
  ]
    .filter(Boolean)
    .join(' ')
    .trim();
}

function isThemeControl(element) {
  return element.matches(
    [
      '.add-to-cart-button',
      '.cart__checkout-button',
      '.quantity-selector button',
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart',
    ].join(',')
  );
}

function isEmptyFullWidthControl(element) {
  const visibleText = (element.textContent || '').replace(/\s+/g, '').trim();

  if (visibleText || element.querySelector('svg, img, [aria-label]')) return false;
  if (element.offsetParent === null) return false;
  if (element.offsetHeight < 36 || element.offsetWidth < 220) return false;

  return true;
}

function hideInjectedCodButton(element) {
  if (isThemeControl(element)) return;

  const text = getElementText(element);
  const shouldHide = COD_PATTERN.test(text) || isEmptyFullWidthControl(element);

  if (!shouldHide) return;

  element.dataset.hideCodInjectedButton = 'true';
  element.setAttribute('aria-hidden', 'true');
  element.setAttribute('tabindex', '-1');
  element.style.display = 'none';

  const wrapper = element.closest('.shopify-app-block, [class*="releasit" i], [id*="releasit" i], [class*="cod" i], [id*="cod" i]');
  if (wrapper && wrapper instanceof HTMLElement) {
    wrapper.dataset.hideCodInjectedButton = 'true';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.style.display = 'none';
  }
}

function cleanInjectedCodButtons(root = document) {
  PRODUCT_AND_CART_SCOPES.forEach((scope) => {
    const containers = new Set();

    if (root instanceof Element) {
      if (root.matches(scope)) containers.add(root);

      const closestScope = root.closest(scope);
      if (closestScope) containers.add(closestScope);
    }

    root.querySelectorAll(scope).forEach((container) => containers.add(container));

    containers.forEach((container) => {
      if (container.matches('button, a, input[type="button"], input[type="submit"], [role="button"]')) {
        hideInjectedCodButton(container);
      }

      container
        .querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"]')
        .forEach(hideInjectedCodButton);
    });
  });
}

cleanInjectedCodButtons();

window.addEventListener('load', () => cleanInjectedCodButtons());
document.addEventListener('shopify:section:load', (event) => cleanInjectedCodButtons(event.target));

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) cleanInjectedCodButtons(node);
    });
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
